module.exports = __webpack_public_path__ + "img/help-desk.c4b256f6.svg";